import React, { Component } from 'react';
// utils
import get from 'lodash.get';
import T from 'prop-types';
import {
  getSkillsAccess,
  getDailyAccess,
  getWeeklyAccess,
  getMonthlyAccess,
} from '../../containers/Routes/utils';
import getUserRelapseAccess from '../../containers/Dashboard/utils/getUserRelapseAccess';
// redux
import { compose } from 'redux';
import { connect } from 'react-redux';
// components
import Icon from '../../components/Icon/Icon';
// hoc
import { withRouter } from 'react-router-dom';
import withSizes from 'react-sizes';
import onClickOutside from 'react-onclickoutside';
import ShrinkedText from '../ShrinkedText/ShrinkedText';
// styles
import classnames from 'classnames/bind';
import styles from './ModulesPanel.mod.css';

const cx = classnames.bind(styles);

const extraModuleIcons = {
  R: 'chevron-double-up',
  S: 'calendar-alt',
  J: 'comment',
  W: 'check-circle',
  M: 'check-square',
};

const extraModulesNames = {
  R: 'Recovery',
  S: 'Skills',
  J: 'Journal',
  D: 'Daily check-in',
  W: 'Weekly check-in',
  M: 'Monthly check-in',
};

class ModulesPanel extends Component {
  state = {
    isOpen: false,
  };

  togglePanel = () => {
    this.setState(({ isOpen }) => {
      return { isOpen: !isOpen };
    });
  };

  handleClickOutside = () => {
    document.body.style.overflow = 'auto';
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  };

  extraModuleClick = key => {
    const { history, isTablet } = this.props;
    key === 'S' && history.push('/skills');
    key === 'J' && history.push('/journal');
    key === 'D' && history.push('/daily-check-in');
    key === 'W' && history.push('/weekly-check-in');
    key === 'M' && history.push('/monthly-check-in');
    if (key === 'R') {
      !isTablet && history.push({ pathname: '/dashboard', state: { id: 'R' } });
      isTablet && history.push('/module/R');
    }
  };

  render() {
    const { hidden, history, modules, user, shrinkedLength } = this.props;
    const { isOpen } = this.state;
    const isClient = user.role === 'client';
    const currentModule = isClient
      ? user.progress.module
      : user.client_person.progress.module;

    const dailyAccess = getDailyAccess(user);
    const weeklyAccess = getWeeklyAccess(user);
    const monthlyAccess = getMonthlyAccess(user);
    const relapseAccess = getUserRelapseAccess(user);
    const skillsAccess = getSkillsAccess(user);

    return modules ? (
      <div className={cx('wrapper', { isOpen })}>
        <div className={cx('bookmark', { hidden })} onClick={this.togglePanel}>
          {currentModule}
        </div>
        <div className={cx('panel')} onClick={this.togglePanel}>
          <div className={cx('main-modules')}>
            {[8, 7, 6, 5, 4, 3, 2, 1].map((key, index) => {
              const isCurrent = currentModule === key;
              const module = modules[key - 1] || modules[0];
              const { description } = module;
              return (
                <div
                  className={cx('main-module', { current: isCurrent })}
                  key={index}
                  onClick={() =>
                    history.push({
                      pathname: '/dashboard',
                      state: { id: key },
                    })
                  }
                >
                  <span className={cx('number')}>{key}</span>
                  <ShrinkedText length={shrinkedLength}>
                    {description}
                  </ShrinkedText>
                  {isCurrent && (
                    <Icon type="arrow-right" className={cx('arrow')} />
                  )}
                </div>
              );
            })}
          </div>
          {isClient && (
            <div className={cx('extra-modules')}>
              {Object.keys(extraModuleIcons).map((key, index) => {
                if (
                  (!relapseAccess && key === 'R') ||
                  (!dailyAccess && key === 'D') ||
                  (!weeklyAccess && key === 'W') ||
                  (!monthlyAccess && key === 'M') ||
                  (!skillsAccess && key === 'S')
                ) {
                  return null;
                }

                return (
                  <div
                    onClick={() => this.extraModuleClick(key)}
                    className={cx('extra-module', {
                      current: String(currentModule) === key,
                    })}
                    key={index}
                  >
                    <Icon className={cx('icon')} type={extraModuleIcons[key]} />
                    {extraModulesNames[key]}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    ) : null;
  }
}

ModulesPanel.propTypes = {
  hidden: T.bool.isRequired,
};

const getShrinkedLength = width => {
  return width > 768 ? 80 : 45;
};

const enhance = compose(
  connect(state => ({
    modules: get(state.program, 'program.programmodules'),
    user: state.auth.user,
  })),
  withRouter,
  withSizes(({ width }) => ({
    shrinkedLength: getShrinkedLength(width),
  })),
  onClickOutside
);

export default enhance(ModulesPanel);



// WEBPACK FOOTER //
// ./src/components/ModulesPanel/ModulesPanel.jsx